import { h } from "preact";

import { AppContext } from "../../AppContext";
import {
    Alert,
    Box,
    Button,
    DialogActions,
    DialogContent,
    Dialog,
    DialogTitle,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Stack,
    Tooltip,
    Typography,
    Grid
} from "@mui/material";
import { useState, useContext, useEffect } from "preact/hooks";

import DeleteIcon from "@mui/icons-material/Delete";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import LoadingButtonWithTooltip from "../Common/LoadingButtonWithTooltip";
import DownloadFile from "../Common/DownloadFile";

export default function DataroomFilesForOneCatDialog(props) {
    const app = useContext(AppContext);

    const handleClose = () => {
        props.onClose();
    };
    const [state, setState] = useState({ mode: "home" });
    console.log("DataroomFilesForOneCatDialog", props.state.params);

    const delFile = () => {
        // console.log(state)

        const requestOptions = {

            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: state.uid })

        };
        fetch("/api/deldoc", requestOptions)
            .then((response) => response.json())
            .then((res) => {
                console.log(res)
                switch (res.res) {
                    case "ok":
                        window.location.replace("/dataroom/" + props.state.params.id + "?pnl=" + props.state.params.panel);
                    case "err":

                        break;
                    default:
                        break;
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={props.state.opened} fullWidth>
            <DialogTitle id="simple-dialog-title"><Typography variant="h5">{`Vos documents déjà téléversés pour ${props.state.params.cat}`}</Typography></DialogTitle>
            <DialogContent style="padding-left: 8px; padding-right: 8px;">
                <Stack spacing={1}>
                    <Alert
                        style={{ padding: "10px" }}
                        severity={"info"}
                        icon={<ContactSupportIcon color="primary" />}>

                        <Typography variant="body">{props.state.params.h}</Typography>
                    </Alert>
                    {state.mode === "home" && props.state.params.doc.r.map((f) => (
                        <Box display={"flex"} justifyContent="flex-start" alignItems={"center"}>
                            <Box>
                                {f.t &&
                                    <img src={`${THUMBS_URL}/${f.st}-100.jpg`} height={100} width={100} style="border: lightgray 1px solid; border-radius: 10px;" />
                                }
                                {!f.t && <InsertDriveFileIcon sx={{
                                    fontSize: 100, color: "#e6e4e4",
                                    border: "1px solid lightgray",
                                    borderRadius: "10px"
                                }} />}
                            </Box>
                            <Box p={1}>
                                <Grid container>
                                    <Grid item xs={12} sm={8}>
                                        <Typography noWrap={true}>{f.name}</Typography>
                                        <Typography variant="caption">{`${f.dt} - ${f.sz}`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box display="flex" justifyContent={"flex-start"} alignItems="center">
                                            <Box >
                                                {/* <Typography display={"inline"} variant="body1" id={`lbl-` + f.u}></Typography> */}
                                                <DownloadFile f={f} mode="docs" />
                                            </Box>
                                            <Box >
                                                {props.state.params.upld && (
                                                    <Tooltip title="Supprimer ce document">
                                                        <IconButton edge="end" aria-label="delete" onClick={() => setState({ ...state, mode: "del", uid: f.u })}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>

                        </Box>

                    ))}
                    {false && state.mode === "home" && <List>
                        {props.state.params.doc.r.map((f) => (
                            <ListItem key={f.u} style={{ padding: "0px" }}>
                                {f.t && <ListItemAvatar>
                                    <img src={`${THUMBS_URL}/${f.st}-100.jpg`} height={100} width={100} style="border: lightgray 1px solid; border-radius: 10px;" />
                                </ListItemAvatar>}
                                {!f.t && <InsertDriveFileIcon sx={{
                                    fontSize: 100, color: "#e6e4e4",
                                    border: "1px solid lightgray",
                                    borderRadius: "10px"
                                }} />}
                                <ListItemText primary={f.name} secondary={`${f.dt} - ${f.sz}`} style="padding: 8px;" />
                                <ListItemSecondaryAction>
                                    <Box display="flex" justifyContent={"space-between"} alignItems="center">
                                        <Box >
                                            <Typography display={"inline"} variant="body1" id={`lbl-` + f.u}></Typography>
                                            <LoadingButtonWithTooltip icon={<DownloadIcon />} id={f.u} label={"télécharger"} click={() => zsx(f.u, f.name)} />
                                        </Box>
                                        <Box >
                                            {props.state.params.u === "U" && props.state.params.upld && (
                                                <Tooltip title="Supprimer ce document">
                                                    <IconButton edge="end" aria-label="delete" onClick={() => setState({ ...state, mode: "del", uid: f.u })}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </Box>
                                    </Box>

                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}

                    </List>}
                    {props.state.params.doc.r.length === 0 && <Typography variant="body1"><em>Aucun document</em></Typography>}
                    {state.mode == "del" && (
                        <Typography variant="h5">Voulez-vous vraiment supprimer ce fichier ?</Typography>
                    )}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" style="width: 100%;">
                    <Box>
                        {state.mode == "del" && (<Button variant="contained" onClick={() => setState({ ...state, mode: "home" })}>annuler</Button>)}
                    </Box>
                    <Box>
                        {state.mode == "del" && (<Button variant="contained" onClick={() => delFile()}>supprimer</Button>)}
                        {state.mode == "home" && props.state.params.upld && props.state.params.doc.r.length < 10 && <Button
                            variant="contained"
                            onClick={() => app.refPopUp.current.handleChangeState(
                                {
                                    opened: true,
                                    type: "034",
                                    params: {
                                        catUid: props.state.params.doc.u,
                                        popup_params: props.state.params
                                    }
                                })}
                        >
                            Ajouter un document
                        </Button>}
                    </Box>
                </Box>
            </DialogActions>
        </Dialog >
    );
}